import {ChangeDetectorRef, Component, Injector, OnInit} from '@angular/core';
import {ApiService} from "../../../../services/api.service";
import {BehaviorSubject} from "rxjs";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {NzNotificationService} from "ng-zorro-antd/notification";
import {UserService} from "../../../../services/user.service";


@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {

  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  EditProfileForm: FormGroup;
  currentUser: any;

  constructor(
    public fb: FormBuilder,
    public api:ApiService,
    public router: Router,
    public user: UserService,
    public notifications: NzNotificationService) {
  }

  ngOnInit(): void {
    this.api.apiGet('/user').then((res)=>{
      this.currentUser = res;
        this.EditProfileForm = this.fb.group({
            name: [res.name, Validators.required],
            email: [res.email, Validators.required],
            profile_picture_upload: [null]
        })
        this.EditProfileForm.controls['email'].disable();
        this.$loading.next(false);

    })
  }

  submitForm(redirect = true){

    const formData: any = new FormData();

    Object.keys(this.EditProfileForm.controls).forEach(key => {
      const value = this.EditProfileForm.get(key)?.value;
      console.log(key);
      console.log(value);
      if(value){
          formData.append(key, this.EditProfileForm.get(key)?.value);
      }
    });

    this.api.apiPost('/user', formData, true).then((res)=>{
      this.notifications.success('Success', 'Your account has been successfully update');
      this.user.currentUserSubject.next(res);
    }).catch((err)=>{
      this.notifications.error('Error', 'There was an error updating your account. Please contact us for support.');
    })

  }


}
